import { forwardRef, HTMLAttributes, ReactNode } from "react";
import { ComboboxOptions } from "@headlessui/react";
import { cn } from "../../../utils/cn";

export interface SelectOptionsProps extends HTMLAttributes<HTMLUListElement> {
  className?: string;
  children: ReactNode;
}

export const SelectOptions = forwardRef<HTMLUListElement, SelectOptionsProps>(
  function SelectOptions({ className, children, ...props }, ref) {
    const css = cn(
      className,
      "absolute min-w-fit z-10 mt-2 max-h-60 w-full overflow-auto rounded-md",
      "bg-white py-1 text-base shadow-lg outline outline-gray-100  sm:text-sm",
    );
    return (
      <div className="relative">
        <ComboboxOptions as={"ul"} ref={ref} className={css} static {...props}>
          {children}
        </ComboboxOptions>
      </div>
    );
  },
);
